module.exports = __webpack_public_path__ + "static/media/1.938c3657.jpg";